module.exports = "//static.hsappstatic.net/LoginUI/static-1.12804/img/login-marketing-image.png"